import React from 'react';
import { CustomCursor } from './components/CustomCursor';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
function App() {
  return <div className="relative bg-background min-h-screen text-primary selection:bg-primary selection:text-background" data-id="element-0">
      {/* Noise Texture for Film Vibe */}
      <div className="fixed inset-0 opacity-[0.02] pointer-events-none z-50" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.85%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-1"></div>

      {/* Custom Cursor */}
      <div className="hidden md:block z-[10000] relative" data-id="element-2">
        <CustomCursor data-id="element-3" />
      </div>

      <div className="relative z-10" data-id="element-4">
        <Navbar data-id="element-5" />
        <main data-id="element-6">
          <Hero data-id="element-7" />
          <About data-id="element-8" />
          <Services data-id="element-9" />
          <Portfolio data-id="element-10" />
          <Stats data-id="element-11" />
          <Testimonials data-id="element-12" />
          <Contact data-id="element-13" />
        </main>
        <Footer data-id="element-14" />
      </div>
    </div>;
}
export { App };